import React, { useState } from 'react';

const FeaturesFooter = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="section is--feature-list">
      <div className="container-2 is--feature-list">
        <div className="section-header">
          <h2 className="h2-2 is--no-paragraph is--features" style={{ display: 'inline-table' }}>
            <span className="big-e">E</span>
            <span style={{ fontSize: '85%', textTransform: 'uppercase' }}>worxs</span>
            {' '} Amazing Features
            <span className="line-break"></span>
          </h2>
        </div>
        <div className="feature-list">
          <div className="feature-list-group">
          </div>
          <button onClick={toggleExpand} className="button is--grey is--expand w-inline-block">
            <div>{isExpanded ? 'See less' : 'See more'}</div>
            <img 
              src="img/arrow1-down.svg" 
              loading="lazy" 
              alt="" 
              className="arrow-down" 
              style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
            />
          </button>
          <div className={`feature-list-group is--expand ${isExpanded ? 'is--visible' : ''}`}>
            <div className="feature-list__item">
              <img src="img/icon07.png" loading="lazy" alt="" className="feature-list__icon" />
              <div className="h4-2 is--small-padding" style={{ fontWeight: '700' }}>Automatic Mileage Tracking</div>
              <div className="text-m is--dimmed">It tracks mileage from your home to your client's location. Just login when you arrive at your client's location.</div>
            </div>
            <div className="feature-list__item">
              <img src="img/icon04.png" loading="lazy" alt="" className="feature-list__icon" />
              <div className="h4-2 is--small-padding" style={{ fontWeight: '700' }}>Work Hours</div>
              <div className="text-m is--dimmed">Just enter your arrival time when you arrive at your client's location then enter your departure time when you leave.</div>
            </div>
            <div className="feature-list__item">
              <div className="doc_cap">
                <img src="img/icon05.png" loading="lazy" alt="" className="feature-list__icon" />
              </div>
              <div style={{ fontWeight: '700' }} className="h4-2 is--small-padding">Document Capturing</div>
              <div className="text-m is--dimmed">Do you need to attach a document to the visit? No problem, just take a picture of the document and upload it to the app!</div>
            </div>
            <div className="feature-list__item">
              <img src="img/icon06.png" loading="lazy" alt="" className="feature-list__icon" />
              <div className="h4-2 is--small-padding" style={{ fontWeight: '700' }}>Automatically generates and sends invoices</div>
              <div className="text-m is--dimmed">When you complete your visit, just press the finish button and you are good to go! The app automatically generates and sends invoices.</div>
            </div>
            <div className="feature-list__item">
              <img src="img/icon09.png" loading="lazy" alt="" className="feature-list__icon" />
              <div className="h4-2 is--small-padding" style={{ fontWeight: '700' }}>Reports</div>
              <div className="text-m is--dimmed">Manage everything from your Dashboard — easily generate reports such as workers’ hours, invoices, and much more!</div>
            </div>
            <div className="feature-list__item">
              <div className="doc_cap" style={{ background: '#84cf83b0' }}>
                <img src="img/icon10.png" loading="lazy" alt="" className="feature-list__icon" />
              </div>
              <div style={{ fontWeight: '700' }} className="h4-2 is--small-padding">QBO integration</div>
              <div className="text-m is--dimmed">Manage invoice integration from your dashboard — easily integrate invoices into QuickBooks with one click from your Dashboard!</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesFooter; 